import UnbindSubcategories from "../symbols/unbindSubcategories";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function UnbindSubcategoriesReducer(state = initialState, action: any) {
  switch (action.type) {
    case UnbindSubcategories.UNBIND_SUBCATEGORIES:
      return { ...state, loading: true, error: false };
    case UnbindSubcategories.UNBIND_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case UnbindSubcategories.UNBIND_SUBCATEGORIES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case UnbindSubcategories.CLEAR_UNBIND_SUBCATEGORIES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default UnbindSubcategoriesReducer;
